// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.multiplex.RentalManagerUserPropertyMultiplexV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  UserPropertyMultiplexPhotoCaptionV2RequestDto,
  UserPropertyMultiplexPhotoDeleteV2RequestDto,
  UserPropertyMultiplexPhotoRankV2RequestDto,
  UserPropertyMultiplexPhotoResponseV2WebDto,
  UserPropertyMultiplexSetListingCriteriaResponseV2WebDto,
  UserPropertyMultiplexSetListingCriteriaV2RequestDto,
  UserPropertyMultiplexUpdateResponseV2WebDto,
  UserPropertyMultiplexUpdateV2RequestDto,
} from '../..';

export const RentalManagerUserPropertyMultiplexV2WebApiHandler_caption_Path =
  '/api/web/v2/users/properties/multiplex/photos/caption';

/**
 * Update photo caption for every unit in a multiplex building session
 */
export const RentalManagerUserPropertyMultiplexV2WebApiHandler_caption = (
  postData: UserPropertyMultiplexPhotoCaptionV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyMultiplexPhotoCaptionV2RequestDto,
    UserPropertyMultiplexPhotoResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyMultiplexV2WebApiHandler_caption_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyMultiplexV2WebApiHandler_delete_Path =
  '/api/web/v2/users/properties/multiplex/photos/delete';

/**
 * Delete a photo from every unit in a multiplex building session
 */
export const RentalManagerUserPropertyMultiplexV2WebApiHandler_delete = (
  postData: UserPropertyMultiplexPhotoDeleteV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyMultiplexPhotoDeleteV2RequestDto,
    UserPropertyMultiplexPhotoResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyMultiplexV2WebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyMultiplexV2WebApiHandler_rank_Path =
  '/api/web/v2/users/properties/multiplex/photos/rank';

/**
 * Update photo rank for every unit in a multiplex building session
 */
export const RentalManagerUserPropertyMultiplexV2WebApiHandler_rank = (
  postData: UserPropertyMultiplexPhotoRankV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyMultiplexPhotoRankV2RequestDto,
    UserPropertyMultiplexPhotoResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyMultiplexV2WebApiHandler_rank_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyMultiplexV2WebApiHandler_setListingCriteria_Path =
  '/api/web/v2/users/properties/multiplex/setListingCriteria';

/**
 * Set listing criteria for all the units in a multiplex building session
 */
export const RentalManagerUserPropertyMultiplexV2WebApiHandler_setListingCriteria = (
  postData: UserPropertyMultiplexSetListingCriteriaV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyMultiplexSetListingCriteriaV2RequestDto,
    UserPropertyMultiplexSetListingCriteriaResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyMultiplexV2WebApiHandler_setListingCriteria_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyMultiplexV2WebApiHandler_update_Path =
  '/api/web/v2/users/properties/multiplex/update';

/**
 * Update listing fields for all the units in a multiplex building session
 */
export const RentalManagerUserPropertyMultiplexV2WebApiHandler_update = (
  postData: UserPropertyMultiplexUpdateV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyMultiplexUpdateV2RequestDto,
    UserPropertyMultiplexUpdateResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyMultiplexV2WebApiHandler_update_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
